import React from "react";

import { OliviaFooter } from "../../media/footer";

const PageFooter = () => {
    // biome-ignore lint/a11y/useAltText: <legacy>
    return <img src={OliviaFooter} height={100} style={{ marginInline: "left" }} />;
};

export default PageFooter;
